import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { resetContext } from 'store/globalState/global';
import { goHome } from 'modules/steps/actions';
import { setBreadcrumb } from 'components/Navbar/modules';
import ThinkSeedCreation from '../components/ThinkSeedCreation';


function mapStateToProps(state) {
  return {
    app: state.app,
    literals: state.i18n.literals.creationThinkSeed,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    resetContext: bindActionCreators(resetContext, dispatch),
    goHome: bindActionCreators(goHome, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ThinkSeedCreation));



// WEBPACK FOOTER //
// ./src/routes/ThinkSeedCreation/container/index.js